import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Report, RowActions } from '../../../../admin/report/report';
import { GetCustomersService } from '../../services/get-customers.service';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../../../../../shared/services/language.service';

@Component({
  selector: 'app-customers-management',
  templateUrl: './customers-management.component.html',
  styleUrls: ['./customers-management.component.scss'],
})
export class CustomersManagementComponent implements OnInit {
  totalNumberOfRecords: number = 0;
  customersReportData: any[] = [];
  requestBody: Report = {};
  loading = false;
  displayedColumns: any[] = [
    'customerBusinessName',
    'firstName',
    'lastName',
    'email',
    'mobile',
    'address',
    'additionalInfo',
  ];
  displayTableColumns = {};
  rowActions: RowActions[] = [
    {
      actionName: 'edit',
      actionType: 'icon',
      iconClass: 'fa-edit',
    },
  ];
  reportName: string = '';

  constructor(
    public getCustomersService: GetCustomersService,
    public dialog: MatDialog,
    private router: Router,
    private translate: TranslateService,
    private languageService: LanguageService,
  ) {}

  async ngOnInit() {
    if (localStorage.getItem('language')) {
      if (localStorage.getItem('language') === 'ar') {
        this.loadArContent();
      } else if (localStorage.getItem('language') === 'en') {
        this.loadEnContent();
      }
    } else {
      this.loadEnContent();
    }
    this.languageService.languageUpdated.subscribe((lang: string) => {
      if (lang === 'ar') {
        this.loadArContent();
      } else if (lang === 'en') {
        this.loadEnContent();
      }
    });
    try {
      this.getCustomersService.activateLoader();
      this.requestBody.paginationOptions = {
        start: 0,
        limit: 10,
      };
      this.updateTable();
    } catch (err) {
      console.log(err);
    }
  }

  loadArContent() {
    this.reportName = 'إدارة العملاء';
    this.translate.use('ar');

    this.displayTableColumns = {
      customerBusinessName: 'اسم عمل العميل',
      firstName: 'الاسم الأول',
      lastName: 'اسم العائلة',
      email: 'بريد إلكتروني',
      mobile: 'رقم التليفون',
      address: 'عنوان',
      additionalInfo: 'معلومات إضافية',
    };
  }

  loadEnContent() {
    this.reportName = 'Customer Management';
    this.translate.use('en');

    this.displayTableColumns = {
      customerBusinessName: 'Customer Business Name',
      firstName: 'First Name',
      lastName: 'Last Name',
      email: 'Email',
      mobile: 'Phone Number',
      address: 'Address',
      additionalInfo: 'Additional Information',
    };
  }

  async filter(event: any) {
    if (event && Object.keys(event).length) {
      this.requestBody.filterOptions = event;
    } else {
      this.requestBody.filterOptions = {};
    }
    this.requestBody.paginationOptions = {
      start: 0,
      limit: 10,
    };
    this.updateTable();
    this.getCustomersService
      .loader()
      .subscribe((val: any) => (this.loading = val));
  }

  async paginate(event: any) {
    this.requestBody.paginationOptions = {
      start: event.pageIndex * event.pageSize,
      limit: event.pageSize,
    };
    this.updateTable();
    this.getCustomersService
      .loader()
      .subscribe((val: any) => (this.loading = val));
  }

  async searchChange(event: any) {
    if (event) {
      this.requestBody.searchOptions = {
        searchKey: event,
      };
    } else {
      this.requestBody.searchOptions = undefined;
      this.getCustomersService
        .loader()
        .subscribe((val: any) => (this.loading = val));
    }
    this.updateTable();
  }
  async sortChange(event: any) {
    if (event.direction === '') {
      this.requestBody.sortOptions = {};
    } else {
      this.requestBody.sortOptions = {
        [`${event.active}`]: event.direction,
      };
    }
    await this.updateTable();
    this.getCustomersService
      .loader()
      .subscribe((val: any) => (this.loading = val));
  }

  async updateTable() {
    this.getCustomersService.activateLoader();
    this.getCustomersService.setParams(this.requestBody);
    const report = await this.getCustomersService.make();
    if (report.success) {
      const data = report.data;
      this.customersReportData = data.result;
      this.totalNumberOfRecords = data.totalNumberOfRows;
    }
  }

  onRowAction(event: any) {
    if (event.action === 'edit') {
      this.router.navigate(['/seller/customers/edit', event.key.id]);
    }
  }
}
